import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Rola a janela para o topo a cada mudança de rota.
 * Garante que páginas como /metodo-livre abram sempre no começo,
 * independentemente de onde o usuário estava na página anterior.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
